import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';

import './index.css';

import App from './App';

ReactDOM.render(

  <Router>
    <App
      appInfo={
        document.getElementById('root').getAttribute('data-app-info')
          ? JSON.parse(
              document.getElementById('root').getAttribute('data-app-info')
            )
          : {
              apiEndpoint: '/api/v1/' // Uncommented this before building (or committing) for production
              //apiEndpoint: 'http://localhost:8088/api/v1/' // only used for local development, change this to where your api lives at your localhost
            }
      }
    />
  </Router>,
  document.getElementById('root')
);
registerServiceWorker();
